@if (invoices) {
  @if (invoices.length) {
    <table>
      <thead><tr>
        <th>{{ 'invoice.number' | translate }}</th><th>{{ 'invoice.status' | translate }}</th>
        <th>{{ 'invoice.period' | translate }}</th><th class="num">{{ 'invoice.total_incl' | translate }}</th>
      </tr></thead>
      <tbody>
        @for (invoice of invoices; track invoice.id) {
          <tr class="link" tabindex="0" (click)="open(invoice)" (keydown.enter)="open(invoice)">
            <td>{{ invoice.number ?? ('invoice.draft_label' | translate:{id: invoice.id}) }}</td>
            <td><bst-invoice-status [invoice]="invoice"></bst-invoice-status></td>
            <td>{{ invoice.period_from | localedate:'D MMM YYYY' }} – {{ invoice.period_to | localedate:'D MMM YYYY' }}</td>
            <td class="num">@if (invoice.gross_cents !== null) { {{ invoice.gross_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }} } @else { <span class="muted">–</span> }</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <p class="muted">{{ 'invoice.none' | translate }}</p>
  }
  <div class="actions">
    <button nbButton size="small" status="primary" (click)="create()"><nb-icon icon="plus-outline"></nb-icon><span>{{ 'invoice.new' | translate }}</span></button>
  </div>
}
